import { useEffect, useState } from 'preact/hooks';
import { api, ApiError } from '../../api.js';
import { t } from '../../i18n/index.js';
import type { AdminPmConversation, PrivateMessage } from '../../../shared/protocol.js';

const dateTime = (ms: number) => new Date(ms).toLocaleString('fi-FI', { dateStyle: 'short', timeStyle: 'short' });

/** Private messages for the administrator (decision 2026-09-27). */
export function MessagesAdmin() {
  const [conversations, setConversations] = useState<AdminPmConversation[]>([]);
  const [open, setOpen] = useState<{ key: string; messages: PrivateMessage[] } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api<{ conversations: AdminPmConversation[] }>('GET', '/api/admin/pm/conversations')
      .then((r) => setConversations(r.conversations))
      .catch((err) => setError(t.errors[err instanceof ApiError ? err.code : 'network']));
  }, []);

  const toggle = async (c: AdminPmConversation) => {
    const key = `${c.a.id}-${c.b.id}`;
    if (open?.key === key) return setOpen(null);
    const r = await api<{ messages: PrivateMessage[] }>('GET', `/api/admin/pm/${c.a.id}/${c.b.id}`);
    setOpen({ key, messages: r.messages });
  };

  return (
    <section class="card">
      <h2>{t.admin.pm.title}</h2>
      <p class="muted">{t.admin.pm.info}</p>
      {error && <p class="error">{error}</p>}
      {conversations.length === 0 ? (
        <p class="muted">{t.admin.pm.none}</p>
      ) : (
        <ul class="user-list">
          {conversations.map((c) => {
            const key = `${c.a.id}-${c.b.id}`;
            return (
              <li class="user-row">
                <div class="user-main">
                  <div class="user-name">
                    {c.a.displayName} ↔ {c.b.displayName}
                  </div>
                  <div class="user-sub">
                    {t.admin.pm.messages(c.count)} · {dateTime(c.lastAt)}
                  </div>
                </div>
                <button class="btn btn-small" onClick={() => void toggle(c)}>
                  {open?.key === key ? t.admin.pm.hide : t.admin.pm.show}
                </button>
                {open?.key === key && (
                  <div class="admin-chat">
                    {open.messages.map((m) => (
                      <div class="chat-msg">
                        <div class="chat-meta">
                          {m.from.displayName} → {m.to.displayName} · {dateTime(m.sentAt)}
                        </div>
                        <div class="chat-text">{m.text}</div>
                      </div>
                    ))}
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
